import { ptBR, enUS, es } from 'date-fns/locale'
import type { Locale } from 'date-fns'
import { useT } from './I18nProvider'
import type { Lang } from './config'

const LOCALES: Record<Lang, Locale> = { 'pt-BR': ptBR, en: enUS, es }

// Locale do date-fns conforme o idioma atual — para format(date, ..., { locale }).
export function useDateFnsLocale(): Locale {
  const { lang } = useT()
  return LOCALES[lang] ?? ptBR
}
